import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const BRANCH_SEARCH_POSTCODE_INVALID = 'waitrose/branches/BRANCH_SEARCH_POSTCODE_INVALID';
export const GET_BRANCH_BY_ID = apiPromiseTypes('branchbyid', 'get');
export const GET_BRANCHES_BY_POSTCODE = apiPromiseTypes('branches', 'get');
export const GET_BRANCHES_LIST = apiPromiseTypes('branchlist', 'get');
